import { render } from "./HistoryItemRow.vue?vue&type=template&id=c3a0b6fa"
import script from "./HistoryItemRow.vue?vue&type=script&lang=js"
export * from "./HistoryItemRow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__